import React from 'react';
import {func} from 'prop-types';

import ActionsPanelItem from '../../components/ActionsPanelItem';

import classes from './ActionInsert.module.css';

const SystemActionInsert = ({
    onToggleCreateSystemModal
}) => {

    return (
        <div className={classes.agentActions}>
            <ActionsPanelItem
                title="Create a new System"
                iconUrl="/assets/images/systemTreeIcon.svg"
                onClick={() => onToggleCreateSystemModal(true)}
            />
        </div>
    );
};

SystemActionInsert.defaultProps = {
    onToggleCreateSystemModal: () => {}
};

SystemActionInsert.propTypes = {
    onToggleCreateSystemModal: func
};

export default SystemActionInsert;
